import React, { useState, useEffect } from 'react';



const Step = ({ number, title, color, isLast  }) => {
    let borderColorClass = "";
    let textColorClass = "";
    
    switch (color) {
        case "pink":
            borderColorClass = "border-pink-500";
            textColorClass = "text-pink-500";
            break;
        case "blue":
            borderColorClass = "border-blue-500";
            textColorClass = "text-blue-500";
            break;
        case "yellow":
            borderColorClass = "border-yellow-500";
            textColorClass = "text-yellow-500";
            break;
        default:
            borderColorClass = "border-gray-500";
            textColorClass = "text-gray-500";
    }

    return (
        <div className="flex  gap-5 ">
            <div className="flex flex-col items-center ">
            <div className={`rounded-full h-14 w-14 flex items-center justify-center  ${borderColorClass} border-2`}>
                <span style={{ color: '#191919', fontWeight: 'bold', fontFamily: 'Arial', fontSize: '18px' }}>{number}</span>
            </div>
            {!isLast && (
    <div className="w-0.5 border-r-2 border-dashed " style={{ height: '50px', borderColor: '#8C8C8C' }}></div>
)}

            </div>
            <div className={`ml-4 mt-3 font-bold   ${textColorClass}` } style={{ fontFamily: 'Arial', fontSize: '20px' }}>
                {title}
            </div>
            
           
        </div>
    );
};
  
const CardWithVideo = ({ firstNumber, firstText, secondNumber, secondText, videoSrc  }) => {
    const fullVideoUrl = videoSrc ? `https://backend.printtrio.co.uk/${videoSrc}` : '';
    return (
        <div className="flex flex-col items-center justify-center p-10 relative " style={{ fontFamily: 'Arial' }}>
<div className="video-frame rounded-lg overflow-hidden   mx-auto" >
    <video className="" controls>
        <source src={fullVideoUrl} type="video/mp4" />
    </video>
</div>

            <div className=" shadow-lg flex p-1 md:p-2 xl:p-3   w-52 md:w-80 xl:w-1/2   absolute bottom-0 mb-0 md:mb-8 xl:mb-12 " style={{ backgroundColor: '#8AC9FF', color: '#191919', borderRadius: '16px', transform: 'translateX(-50%)', left: '61%',bottom: '75%'}}>
                <div className="flex items-center gap-3 " >
                    <div className="text-xl md:text-2xl font-bold">{firstNumber}</div>
                    <div className="ml-2 text-xs md:text-lg" >{firstText}</div>
                </div>
                <div className="border-r border-black mx-2 md:mx-3 xl:mx-7" style={{ height: '50px' }}></div>
                <div className="flex items-center gap-1">
                    <div className="text-xl md:text-2xl font-bold">{secondNumber}</div>
                    <div className="ml-2 text-xs md:text-lg">{secondText}</div>
                </div>
            </div>
        </div>
    );
};
  

const Printtrio = () => {

    const [data, setData] = useState(null);

    useEffect(() => {
      const fetchData = async () => {
        try {
          const response = await fetch('https://backend.printtrio.co.uk/api/home/get-process');
          const result = await response.json();
          
          if (result.success) {
            setData(result.data[0]);
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      };
  
      fetchData();
    }, []);
  
    if (!data) {
      return <div></div>;
    }
    if (!data || Number(data.is_active) === 0) return null;
  return (
    <div className="w-full  py-10 max-w-screen-2xl mx-auto px-4 relative">
     
        
     <div className="flex flex-col xl:flex-row justify-between items-center mt-14 mb-12 w-full">
  <h1 className="text-xl md:text-3xl xl:text-5xl px-0 xl:px-10 mb-5 xl:mb-0" style={{ fontFamily: 'Arial', color: '#191919' }}>{data.header}</h1>
  <p className="text-base text-gray-500 px-10 xl:px-10 mr-0 xl:mr-14" style={{ maxWidth: '40rem' }}> {data.description}</p>
</div>

<div className="flex flex-col xl:flex-row items-center justify-between bg-white px-0 xl:px-0">
<div className="flex flex-col items-start justify-center p-12 w-full">
    <Step number="01" title={data.first_process} color="pink" />
    <Step number="02" title={data.second_process} color="blue" />
    <Step number="03" title={data.third_process} color="yellow" isLast />
</div>
<div className="p-1 " style={{ fontFamily: 'Arial' , fontSize: '14px' }}>
<CardWithVideo 
    firstNumber={data.first_number}
    firstText={data.first_title} 
    secondNumber={data.second_number}
    secondText={data.second_title} 
    videoSrc={data.video} 
/>
</div>
</div>

       

    </div>
  );
};

export default Printtrio;
